import React from "react";
import {CircularProgress, Stack} from "@mui/joy";

// components
import CommonInfoTab from "../Common/CommonInfoTab";
import RouteTab from "../Route/RouteTab";
import LeadConvertModal from "./LeadConvertModal";
import BaseApi from "../../utils/BaseApi";
import CallsListModal from "../Communication/CallsListModal";

// icons
import InfoIcon from '@mui/icons-material/Info';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import ContactsTab from "../Contact/ContactsTab";


class LeadTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lead: this.props.lead,
        };
    }

    async retrieveLead() {
        await this.setState(
            {
                lead: null
            }
        );
        const url = `lead/${this.props.lead.id}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        await this.setState(
            {
                lead: response.data
            }
        );
    }
    
    render() {
        if (!this.state.lead) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
            >
                <RouteTab
                    entity={'Lead'}
                    entity_id={this.state.lead.id}
                />
                {
                    this.state.lead.ready_to_convert && this.state.lead.status !== 'CLOSE'?
                        <LeadConvertModal
                            lead={this.state.lead}
                            noOpportunity={this.state.lead.xtype === 'outgoing'}
                            callBack={this.props.callBack}
                        />:
                        null
                }
                <CommonInfoTab
                    callBack={this.retrieveLead.bind(this)}
                    groups={[
                        {
                            title: 'Основная информация',
                            icon: <InfoIcon />,
                            fields: [
                                {
                                    title: 'Компания из запроса',
                                    value: this.state.lead.account_title,
                                    md: 12,
                                    lg: 12,
                                    edit: {
                                        permission: true,
                                        fields: ['account_title', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                                {
                                    title: 'ИНН',
                                    value: this.state.lead.inn,
                                    edit: {
                                        permission: true,
                                        fields: ['inn', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                                {
                                    title: 'Сайт',
                                    value: this.state.lead.url,
                                    edit: {
                                        permission: true,
                                        fields: ['url', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },

                                    linkPattern: this.state.lead.url,
                                    linkTarget: '_blank',
                                },
                                {
                                    title: 'Описание',
                                    value: this.state.lead.desc,
                                    html: true,
                                    md: 12,
                                    lg: 12,
                                    edit: {
                                        permission: true,
                                        fields: ['desc', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                            ]
                        },
                        {
                            title: 'Привязки',
                            icon: <PrecisionManufacturingIcon />,
                            fields: [
                                {
                                    title: 'Компания в CRM',
                                    value: this.state.lead.account?.nameshort,
                                    linkPattern: '/account/detail/:linkParam',
                                    linkParam: this.state.lead.account?.id,
                                },
                                // {
                                //     title: 'Контакт в CRM',
                                //     value: this.state.lead.contact?`${this.state.lead.contact?.last_name} ${this.state.lead.contact?.first_name} ${this.state.lead?.contact?.patronymic} - ${this.state.lead.contact?.role}`:null,
                                //     linkPattern: '/contact/detail/:linkParam',
                                //     linkParam: this.state.lead.contact?.id,
                                // },
                                {
                                    title: 'Сделка',
                                    value: this.state.lead.opportunity?this.state.lead.opportunity?.short_name:null,
                                    linkPattern: '/opportunity/detail/:linkParam',
                                    linkParam: this.state.lead.opportunity?.id,
                                },
                            ]
                        },
                        {
                            title: 'Новые контакты из лида',
                            icon: <InfoIcon />,
                            components: [
                                {
                                    component: ContactsTab,
                                    componentProps: {
                                        entity: 'Lead',
                                        entity_id: this.state.lead.id
                                    }
                                }
                            ],
                        },
                        ...this.state.lead.account?[
                            {
                                title: 'Контакты компании',
                                icon: <InfoIcon />,
                                components: [
                                    {
                                        component: ContactsTab,
                                        componentProps: {
                                            entity: 'Account',
                                            entity_id: this.state.lead.account.id,
                                            hideCreate: true,
                                        }
                                    }
                                ],
                            },
                        ]:[],

                        {
                            title: 'Источник и метки',
                            icon: <AdsClickIcon />,
                            fields: [
                                {
                                    title: 'Источник',
                                    value: this.state.lead.source?.title,
                                    edit: {
                                        permission: true,
                                        fields: ['source', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                                {
                                    title: 'Номер кампании Direct',
                                    value: this.state.lead.ya_campaign_number,
                                    edit: {
                                        permission: true,
                                        fields: ['ya_campaign_number', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                                {
                                    title: 'Номер группы Direct',
                                    value: this.state.lead.ya_group_number,
                                    edit: {
                                        permission: true,
                                        fields: ['ya_group_number', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                                {
                                    title: 'Ключевая фраза Direct',
                                    value: this.state.lead.ya_keyword,
                                    edit: {
                                        permission: true,
                                        fields: ['ya_keyword', ],
                                        baseUrl: 'lead',
                                        obj: this.state.lead
                                    },
                                },
                            ]
                        },
                    ]}
                />
            </Stack>

        )
    }
}

export default LeadTab